import contentLoaderTemplate from './contentLoader.html';

class ContentLoaderService {
  constructor($uibModal, $q) {
    this.dialogsToShow = [];
    this.currentShownDialog = null;
    this.$uibModal = $uibModal;
    this.$q = $q;
  }

  show(){
    var dialog = {
      template: contentLoaderTemplate,
      keyboard: false,
      windowClass: 'content-loader'
    };
    this.dialogsToShow.push(dialog);
    this.showNextDialog();

  }

  showNextDialog(){
    if (!this.currentShownDialog && this.dialogsToShow.length > 0) {
      this.currentShownDialog = this.$uibModal.open(this.dialogsToShow.pop());
    }
  }

  hide(){
    if (this.currentShownDialog){
      this.currentShownDialog.close();
      delete this.currentShownDialog;
      this.showNextDialog();
    }
  }
}

ContentLoaderService.$inject = ['$uibModal', '$q'];

export default ContentLoaderService;



// WEBPACK FOOTER //
// ./app/common/contentLoader/contentLoader.service.js